import styled from 'styled-components';

import { useTranslation } from 'react-i18next';
import { PackageTitleStars } from '../PackageTitleStars';
import { breakpoints, colors } from '../../constants';

interface IProps {
    starAmount: number;
    className?: string;
}

const BasePackageNameDisplay: React.FC<IProps> = ({
    starAmount,
    className,
}) => {
    const { t } = useTranslation();

    return (
        <div className={className}>
            <h3>
                {t('glassesPackage')}{' '}
                <PackageTitleStars starAmount={starAmount} />
            </h3>
        </div>
    );
};

export const PackageNameDisplay = styled(BasePackageNameDisplay)`
    font-size: 2.4rem;
    line-height: 1;

    @media (${breakpoints.mediumMin}) {
        margin-bottom: 0;
    }

    h3 {
        font-size: 20px;
        color: ${colors.greenDark};
    }

    ${PackageTitleStars} {
        margin-left: 8px;
    }
`;
